import { PayloadAction, createAction, createSlice } from '@reduxjs/toolkit';
import { IACSJobDetails } from 'interfaces/Jobs/IACSJobDetails';
import { ICognitiveJobState } from './cognitiveJobState';
import { IACSJobRequest } from 'interfaces/Jobs/IACSJobRequest';

const initialState: ICognitiveJobState = {
  jobCount: 0,
  jobs: [],
  filters: [],
  selectedJobId: undefined,
  selectedJobDetails: {} as IACSJobDetails,
  pageSize: '40',
  pageNumber: '1',
  requestFilter: {} as IACSJobRequest,
  isLoading: false,
};

const fetchJobs = createAction(
  'FETCH_ACS_JOBS',
  function prepare(fetchJobACSRequest: IACSJobRequest) {
    return {
      payload: {
        ...fetchJobACSRequest,
      },
    };
  },
);

const getJobDetailsAction = createAction<number>('GET_JOB_DETAILS');

const cognitiveJobSlice = createSlice({
  name: 'cognitiveJobs',
  initialState,
  reducers: {
    setJobsACS(state, action: PayloadAction<ICognitiveJobState>) {
      if (action.payload?.pageNumber && action.payload?.jobs) {
        state.jobs = [...state.jobs, ...action.payload.jobs];
      } else {
        state.jobs = action.payload?.jobs;
      }
      state.jobCount = action.payload?.jobCount;
      state.filters = action.payload?.filters;
    },
    resetSelectedJobDetails(state) {
      return {
        ...state,
        selectedJobId: undefined,
        selectedJobDetails: {} as IACSJobDetails,
      };
    },
    setSelectedJobDetails(state, action: PayloadAction<IACSJobDetails>) {
      return {
        ...state,
        selectedJobId: action.payload.jobID,
        selectedJobDetails: action.payload,
      };
    },
    setRequestFilter(state, action: PayloadAction<IACSJobRequest>) {
      return {
        ...state,
        requestFilter: action.payload,
      };
    },
    setLoadingState(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        isLoading: action.payload,
      };
    },
  },
});

export const cognitiveJobActions = {
  ...cognitiveJobSlice.actions,
  fetchJobs,
  getJobDetailsAction,
};

export default cognitiveJobSlice.reducer;
